import app from 'app';
import Vue from 'vue';
import wtEllipsisAnimation from 'components/animations/wtEllipsisAnimation.component.vue';
import wtGalleryAsset from 'components/assets/wtGalleryAsset.component.vue';
import wtLightboxAsset from 'components/assets/wtLightboxAsset.component.vue';
import wtUserAssetsActions from 'components/assets/wtUserAssetsActions.component.vue';
import wtButton from 'components/buttons/wtButton.component.vue';
import wtClose from 'components/buttons/wtClose.component.vue';
import wtCollapse from 'components/collapse/wtCollapse.component.vue';
import wtCollapseItem from 'components/collapse/wtCollapseItem.component.vue';
import wtBaseDialog from 'components/dialogs/wtBaseDialog.component.vue';
import wtSvgAnimation from 'components/animations/wtSvgAnimation.component.vue';
import wtDropdown from 'components/dropdowns/wtDropdown.component.vue';
import wtDropdownView from 'components/dropdowns/wtDropdownView.component.vue';
import wtProgrammersDropdown from 'components/dropdowns/wtProgrammersDropdown.component.vue';
import wtOrganizationsDropdown from 'components/dropdowns/wtOrganizationsDropdown.component.vue';
import wtCarouselGallery from 'components/galleries/wtCarouselGallery.component.vue';
import wtGridImagesGallery from 'components/galleries/wtGridImagesGallery.component.vue';
import wtAutoComplete from 'components/inputs/autoComplete/wtAutoComplete.component.vue';
import wtInstagramAutoComplete from 'components/inputs/autoComplete/wtInstagramAutoComplete.component.vue';
import wtTwitterAutoComplete from 'components/inputs/autoComplete/wtTwitterAutoComplete.component.vue';
import wtToggle from 'components/inputs/wtToggle.component.vue';
import wtCheckbox from 'components/inputs/wtCheckbox.component.vue';
import wtRadiobox from 'components/inputs/wtRadiobox.component.vue';
import wtSearch from 'components/inputs/wtSearch.component.vue';
import wtSearch2014 from 'components/inputs/wtSearch2014.component.vue';
import wtMultirange from 'components/inputs/wtMultirange.component.vue';
import wtRadioLine from 'components/inputs/wtRadioLine.component.vue';
import wtTextField from 'components/inputs/wtTextField.component.vue';
import wtRadioText from 'components/inputs/wtRadioText.component.vue';
import wtAspectRatioSelector from 'components/inputs/wtAspectRatioSelector.component.vue';
import wtProgressNative from 'components/inputs/wtProgressNative.component.vue';
import wtRadioCircle from 'components/inputs/wtRadioCircle.component.vue';
import wtFile from 'components/inputs/wtFile.component.vue';
import wtDuration from 'components/inputs/wtDuration.component.vue';
import wtDatePicker from 'components/inputs/wtDatePicker.component.vue';
import wtGoogleLikeLoader from 'components/loaders/wtGoogleLikeLoader.component.vue';
import wtScanningEye from 'components/loaders/wtScanningEye.component.vue';
import wtAddComment from 'components/modals/types/wtAddComment.component.vue';
import wtPromptTemplateNameInput from 'components/modals/types/wtPromptTemplateNameInput.component.vue';
import wtAddWallpaper from 'components/modals/types/wtAddWallpaper.component.vue';
import wtEditAssetDetails from 'components/modals/types/wtEditAssetDetails.component.vue';
import wtMakeCopy from 'components/modals/types/wtMakeCopy.component.vue';
import wtSelectProgrammer from 'components/modals/types/wtSelectProgrammer.component.vue';
import wtRebrand from 'components/modals/types/wtRebrand.component.vue';
import wtSlack from 'components/modals/types/wtSlack.component.vue';
import wtTranslateStory from 'components/modals/types/wtTranslateStory.component.vue';
import wtBaseModal from 'components/modals/wtBaseModal.component.vue';
import wtBasePanel from 'components/panels/wtBasePanel.component.vue';
import wtColorPicker from 'components/pickers/color/wtColorPicker.component.vue';
import wtPlayerAudio from 'components/players/wtPlayerAudio.component.vue';
import wtPlayerVideo from 'components/players/wtPlayerVideo.component.vue';
import wtSlider from 'components/sliders/wtSlider.component.vue';
import wtTabs from 'components/tabs/wtTabs.component.vue';
import wtAddKeywords from 'components/tags/wtAddKeywords.component.vue';
import wtTagsList from 'components/tags/wtTagsList.component.vue';
import wtPopover from 'components/popover/wtPopover.component.vue';
import wtContinuousPagination from 'components/wrappers/wtContinuousPagination.component.vue';
import wtFilesDropzone from 'components/wrappers/wtFilesDropzone.component.vue';
import wtRecordMouseMove from 'components/wrappers/wtRecordMouseMove.component.vue';
import wtScrollableHorizontal from 'components/wrappers/wtScrollableHorizontal.component.vue';
import wtVolumeControl from 'components/wrappers/wtVolumeControl.component.vue';
import wtCopyLink from 'components/wtCopyLink.component.vue';
import wtIconWithText from 'components/wtIconWithText.component.vue';
import wtMastheadLikeHeader from 'components/wtMastheadLikeHeader.component.vue';
import wtThumbnailConfirm from 'components/wtThumbnailConfirm.component.vue';
import wtAspectRatioTag from 'components/tags/wtAspectRatioTag.component.vue';

Vue.component('wt-ellipsis-animation', wtEllipsisAnimation);
Vue.component('wt-gallery-asset', wtGalleryAsset);
Vue.component('wt-lightbox-asset', wtLightboxAsset);
Vue.component('wt-user-assets-actions', wtUserAssetsActions);
Vue.component('wt-button', wtButton);
Vue.component('wt-close', wtClose);
Vue.component('wt-collapse', wtCollapse);
Vue.component('wt-collapse-item', wtCollapseItem);
Vue.component('wt-base-dialog', wtBaseDialog);
Vue.component('wt-svg-animation', wtSvgAnimation);
Vue.component('wt-dropdown', wtDropdown);
Vue.component('wt-dropdown-view', wtDropdownView);
Vue.component('wt-programmers-dropdown', wtProgrammersDropdown);
Vue.component('wt-organizations-dropdown', wtOrganizationsDropdown);
Vue.component('wt-carousel-gallery', wtCarouselGallery);
Vue.component('wt-grid-images-gallery', wtGridImagesGallery);
Vue.component('wt-auto-complete', wtAutoComplete);
Vue.component('wt-instagram-auto-complete', wtInstagramAutoComplete);
Vue.component('wt-twitter-auto-complete', wtTwitterAutoComplete);
Vue.component('wt-toggle', wtToggle);
Vue.component('wt-check-box', wtCheckbox);
Vue.component('wt-radio-box', wtRadiobox);
Vue.component('wt-search', wtSearch);
Vue.component('wt-search-2014', wtSearch2014);
Vue.component('wt-multirange', wtMultirange);
Vue.component('wt-radio-line', wtRadioLine);
Vue.component('wt-text-field', wtTextField);
Vue.component('wt-radio-text', wtRadioText);
Vue.component('wt-aspect-ratio-selector', wtAspectRatioSelector);
Vue.component('wt-progress-native', wtProgressNative);
Vue.component('wt-radio-circle', wtRadioCircle);
Vue.component('wt-file', wtFile);
Vue.component('wt-duration', wtDuration);
Vue.component('wt-date-picker', wtDatePicker);
Vue.component('wt-google-like-loader', wtGoogleLikeLoader);
Vue.component('wt-scanning-eye', wtScanningEye);
Vue.component('wt-add-comment', wtAddComment);
Vue.component('wt-prompt-template-name-input', wtPromptTemplateNameInput);
Vue.component('wt-add-wallpaper', wtAddWallpaper);
Vue.component('wt-edit-asset-details', wtEditAssetDetails);
Vue.component('wt-make-copy', wtMakeCopy);
Vue.component('wt-select-programmer', wtSelectProgrammer);
Vue.component('wt-rebrand', wtRebrand);
Vue.component('wt-slack', wtSlack);
Vue.component('wt-translate-story', wtTranslateStory);
Vue.component('wt-base-modal', wtBaseModal);
Vue.component('wt-base-panel', wtBasePanel);
Vue.component('wt-color-picker', wtColorPicker);
Vue.component('wt-player-audio', wtPlayerAudio);
Vue.component('wt-player-video', wtPlayerVideo);
app.namespace.Vue.WtSliderComponent = Vue.component('wt-slider', wtSlider);
Vue.component('wt-tabs', wtTabs);
Vue.component('wt-add-keywords', wtAddKeywords);
Vue.component('wt-tags-list', wtTagsList);
Vue.component('wt-popover', wtPopover);
Vue.component('wt-continuous-pagination', wtContinuousPagination);
Vue.component('wt-files-dropzone', wtFilesDropzone);
Vue.component('wt-record-mouse-move', wtRecordMouseMove);
Vue.component('wt-scrollable-horizontal', wtScrollableHorizontal);
Vue.component('wt-volume-control', wtVolumeControl);
Vue.component('wt-copy-link', wtCopyLink);
Vue.component('wt-icon-with-text', wtIconWithText);
Vue.component('wt-masthead-like-header', wtMastheadLikeHeader);
Vue.component('wt-thumbnail-confirm', wtThumbnailConfirm);
Vue.component('wt-aspect-ratio-tag', wtAspectRatioTag);
